import { defineMessages } from 'react-intl';

export default defineMessages({
    summaryVehicleX: {
        id: 'ml.quoteandbind.pa.policySummary.VEHICLE x',
        defaultMessage: 'VEHICLE {vehicleIndex}'
    },
    summaryEditCoverages: {
        id: 'ml.quoteandbind.pa.policySummary.Edit coverages',
        defaultMessage: 'Edit coverages'
    },
    summaryNamedNonOwner: {
        id: 'ml.quoteandbind.pa.policySummary.Named Non-Owner Coverage',
        defaultMessage: 'Named Non-Owner Coverage'
    },
    summaryNamedNonOwnerTooltipTitle: {
        id: 'ml.quoteandbind.pa.policySummary.Named Non-Owner.What is a Named Non-Owner policy?',
        defaultMessage: 'What is a Named Non-Owner policy?'
    },
    summaryNamedNonOwnerTooltipContent: {
        id: 'ml.quoteandbind.pa.policySummary.Named Non-Owner.tooltipContent',
        defaultMessage: 'A Named Non-Owner Coverage policy is for persons who do not own a vehicle or have one available for their use. This policy will provide Liability coverage when you drive a non-owned vehicle, whether that vehicle is borrowed or rented.'
    },
    coverageTotal: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.Coverage Total',
        defaultMessage: 'Coverage Total'
    },
    vehicleTotal: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.Vehicle Total',
        defaultMessage: 'Vehicle Total'
    },
    whatIsNotIncludedInPremium: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.What is not included in this premium?',
        defaultMessage: 'What is not included in this premium?'
    },
    premiumNotIncludeFeesOrTaxes: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.The premium shown does not include fees or taxes.',
        defaultMessage: 'The premium shown does not include fees or taxes.'
    },
    summaryAnnualTerm: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.term./year',
        defaultMessage: '/year'
    },
    summaryHalfYearTerm: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.term./6 months',
        defaultMessage: '/6 months'
    },
    summaryVinX: {
        id: 'ml.quoteandbind.pa.policySummary.vehicles.vinX',
        defaultMessage: 'VIN # {number}'
    },
    summaryNamedNonOwnerTooltipContentNP: {
        id: 'ml.quoteandbind.pa.policySummary.Named Non-Owner.summaryNamedNonOwnerTooltipContentNP',
        defaultMessage: 'A Non-Owner Coverage policy is for persons who do not own a vehicle or have one available for their use. This policy will provide Liability coverage when you drive a non-owned vehicle, whether that vehicle is borrowed or rented.'
    },
    nonOwnerHeadingNP:{
        id: 'ml.quoteandbind.pa.policySummary.nonOwnerHeadingNP',
        defaultMessage: 'Non Owner Coverage'
    },
      nonOwnerHeading:{
        id: 'ml.quoteandbind.pa.policySummary.nonOwnerHeading',
        defaultMessage: 'Named Non-Owner Coverage'
    }
});
